// @generated
// This file was automatically generated and should not be edited.

export enum ADDENDUM_SORT_FIELD {
  bidPackageName = 'bidPackageName',
  createdAt = 'createdAt',
  status = 'status',
}

export enum ADDENDUM_STATUS {
  approvalPending = 'approvalPending',
  approved = 'approved',
  draft = 'draft',
  objectivelyRecognized = 'objectivelyRecognized',
  rejected = 'rejected',
  withdrawn = 'withdrawn',
}

export enum ADMINS_SORT_FIELD {
  email = 'email',
  name = 'name',
}

export enum ADMIN_AI_EXPERIMENT_BOQ_PROCESSING_SCRIPT {
  linearizeAndReduceV1 = 'linearizeAndReduceV1',
  linearizeAndReduceV1NoHtml = 'linearizeAndReduceV1NoHtml',
}

export enum ADMIN_AI_PLAYGROUND_EXPERIMENT_SORT_FIELD {
  createdAt = 'createdAt',
  createdByName = 'createdByName',
  name = 'name',
  updatedAt = 'updatedAt',
}

export enum ADMIN_BID_PACKAGES_SORT_FIELD {
  biddersWithSubmittedBids = 'biddersWithSubmittedBids',
  bidsDueAt = 'bidsDueAt',
  marketplaceSuggestionsSent = 'marketplaceSuggestionsSent',
  name = 'name',
  projectName = 'projectName',
  publishedToMarketplaceAt = 'publishedToMarketplaceAt',
}

export enum ADMIN_BID_PACKAGE_BILL_OF_QUANTITIES_REVISIONS_SORT_FIELD {
  revision = 'revision',
}

export enum ADMIN_STATUS {
  active = 'active',
  inactive = 'inactive',
  inviteCanceled = 'inviteCanceled',
  inviteFailed = 'inviteFailed',
  invited = 'invited',
}

export enum ADMIN_SUBCONTRACTORS_IMPORT_REQUESTS_SORT_FIELD {
  createdAt = 'createdAt',
  status = 'status',
}

export enum ADMIN_SUBCONTRACTORS_SORT_FIELD {
  name = 'name',
}

export enum ADMIN_SUBCONTRACTOR_FILTER_TYPE {
  all = 'all',
  allExcludingLinked = 'allExcludingLinked',
  company = 'company',
  network = 'network',
  networkAndCompany = 'networkAndCompany',
}

export enum AGENT_COMPANY_ONBOARDING_ITEM_TYPE {
  addReferenceProject = 'addReferenceProject',
  completeCompanyProfile = 'completeCompanyProfile',
  createOwnRequest = 'createOwnRequest',
  discoverCosunoMarketplace = 'discoverCosunoMarketplace',
  inviteColleagues = 'inviteColleagues',
  respondToRequests = 'respondToRequests',
  saveSearch = 'saveSearch',
  specifyMainTrades = 'specifyMainTrades',
  uploadCertificates = 'uploadCertificates',
}

export enum AddendumAuthActions {
  delete = 'delete',
  update = 'update',
  updateStatus = 'updateStatus',
  updateStatusApprove = 'updateStatusApprove',
  view = 'view',
}

export enum AdminAuthActions {
  cancelOrRestoreInvite = 'cancelOrRestoreInvite',
  deactivate = 'deactivate',
  invite = 'invite',
  reactivate = 'reactivate',
  update__permissions = 'update__permissions',
  update__personalInfo = 'update__personalInfo',
  view = 'view',
}

export enum BIDDER_STATUS {
  new = 'new',
  pending = 'pending',
  responsive = 'responsive',
  unresponsive = 'unresponsive',
}

export enum BIDS_SORT_FIELD {
  awardedAt = 'awardedAt',
  bidPackageName = 'bidPackageName',
  bidPackageStatus = 'bidPackageStatus',
  officeName = 'officeName',
  projectName = 'projectName',
  submittedAt = 'submittedAt',
}

export enum BID_AWARDED_SUM_TYPE {
  lumpSum = 'lumpSum',
  unitPricesFromBoQ = 'unitPricesFromBoQ',
}

export enum BID_INVITE_REMINDER_SCHEDULE {
  everyTwoWeeks = 'everyTwoWeeks',
  none = 'none',
  oneDayBeforeDue = 'oneDayBeforeDue',
  oneWeekBeforeDue = 'oneWeekBeforeDue',
  threeDaysBeforeDue = 'threeDaysBeforeDue',
  twoWeeksBeforeDue = 'twoWeeksBeforeDue',
  weekly = 'weekly',
}

export enum BID_INVITE_STATUS {
  draft = 'draft',
  failed = 'failed',
  opened = 'opened',
  sent = 'sent',
  viewed = 'viewed',
}

export enum BID_INVITE_STATUS_CHANGE_STATUS {
  draft = 'draft',
  failed = 'failed',
  opened = 'opened',
  restored = 'restored',
  sent = 'sent',
  viewed = 'viewed',
  withdrawn = 'withdrawn',
}

export enum BID_PACKAGES_MARKETPLACE_SORT_FIELD {
  bidsDueAt = 'bidsDueAt',
  distance = 'distance',
  name = 'name',
  projectName = 'projectName',
  publishedToMarketplaceAt = 'publishedToMarketplaceAt',
  recommended = 'recommended',
}

export enum BID_PACKAGES_SORT_FIELD {
  addendaTotalGross = 'addendaTotalGross',
  addendaTotalNet = 'addendaTotalNet',
  awardedBidAndAddendaTotalNet = 'awardedBidAndAddendaTotalNet',
  awardedBidTotalGross = 'awardedBidTotalGross',
  awardedBidTotalNet = 'awardedBidTotalNet',
  bidRequestsAwaitingResponseCount = 'bidRequestsAwaitingResponseCount',
  bidsDueAt = 'bidsDueAt',
  budget = 'budget',
  name = 'name',
  number = 'number',
  projectName = 'projectName',
  status = 'status',
}

export enum BID_PACKAGE_STATUS {
  bidAwarded = 'bidAwarded',
  closed = 'closed',
  contractSigning = 'contractSigning',
  contracted = 'contracted',
  draft = 'draft',
  inNegotiation = 'inNegotiation',
  published = 'published',
}

export enum BID_REQUESTS_SORT_FIELD {
  bidDueAt = 'bidDueAt',
  bidPackageName = 'bidPackageName',
  bidRequestStatus = 'bidRequestStatus',
  bidRequestStatusForAgent = 'bidRequestStatusForAgent',
  companyName = 'companyName',
  distanceInKms = 'distanceInKms',
  lastStatusChangeAt = 'lastStatusChangeAt',
  officeName = 'officeName',
  projectName = 'projectName',
  projectNumber = 'projectNumber',
  subcontractorName = 'subcontractorName',
}

export enum BID_REQUEST_DECLINED_REASON {
  companyClosed = 'companyClosed',
  distanceTooLarge = 'distanceTooLarge',
  insufficientCapacity = 'insufficientCapacity',
  notOfferingThisService = 'notOfferingThisService',
  other = 'other',
}

export enum BID_REQUEST_SOURCE {
  invite = 'invite',
  marketplace = 'marketplace',
}

export enum BID_REQUEST_STATUS {
  accepted = 'accepted',
  bidAwarded = 'bidAwarded',
  bidRejected = 'bidRejected',
  bidSubmitted = 'bidSubmitted',
  inNegotiation = 'inNegotiation',
  inviteDeclined = 'inviteDeclined',
  invited = 'invited',
  opened = 'opened',
  pendingInvite = 'pendingInvite',
  undecided = 'undecided',
  viewed = 'viewed',
  watched = 'watched',
  withdrawn = 'withdrawn',
}

export enum BID_REQUEST_STATUS_CHANGED_BY {
  anonymousSubcontractor = 'anonymousSubcontractor',
  user = 'user',
}

export enum BID_REQUEST_STATUS_FOR_AGENT {
  accepted = 'accepted',
  bidAwarded = 'bidAwarded',
  bidLost = 'bidLost',
  bidSubmitted = 'bidSubmitted',
  closed = 'closed',
  contractSigning = 'contractSigning',
  contracted = 'contracted',
  declined = 'declined',
  pending = 'pending',
  undecided = 'undecided',
  watched = 'watched',
  withdrawn = 'withdrawn',
}

export enum BID_REQUEST_TYPE {
  createdByAgent = 'createdByAgent',
  createdByPrincipal = 'createdByPrincipal',
}

export enum BID_STATUS {
  awarded = 'awarded',
  draft = 'draft',
  generated = 'generated',
  submitted = 'submitted',
}

export enum BILLING_FREQUENCY {
  monthly = 'monthly',
  quarterly = 'quarterly',
  yearly = 'yearly',
}

export enum BOQ_COMPARISON_MODE {
  average = 'average',
  customBudget = 'customBudget',
  ideal = 'ideal',
  lowest = 'lowest',
  prediction = 'prediction',
}

export enum BOQ_CONTAINER_TYPE {
  bid = 'bid',
  bidPackage = 'bidPackage',
  boqTemplate = 'boqTemplate',
}

export enum BOQ_EDITING_STATUS {
  complete = 'complete',
  empty = 'empty',
  incomplete = 'incomplete',
}

export enum BOQ_EDIT_OPERATION {
  addElement = 'addElement',
  clearField = 'clearField',
  deleteElement = 'deleteElement',
  fillOutField = 'fillOutField',
  moveElement = 'moveElement',
  renumber = 'renumber',
  togglePositionType = 'togglePositionType',
  updateProjectInformation = 'updateProjectInformation',
}

export enum BOQ_ELEMENT_TYPE_DISCRIMINATOR {
  AdditionalText = 'AdditionalText',
  ExecutionDescriptionDto = 'ExecutionDescriptionDto',
  NoteTextDto = 'NoteTextDto',
  PositionDto = 'PositionDto',
  ServiceSpecificationGroupDto = 'ServiceSpecificationGroupDto',
  SubDescriptionDto = 'SubDescriptionDto',
}

export enum BOQ_EXCHANGE_PHASE {
  alternativeProposal = 'alternativeProposal',
  contract = 'contract',
  costEstimation = 'costEstimation',
  proposal = 'proposal',
  requestForProposal = 'requestForProposal',
}

export enum BOQ_FILE_FORMAT {
  gaeb90 = 'gaeb90',
  gaebXml = 'gaebXml',
  oenorm = 'oenorm',
  xlsx = 'xlsx',
}

export enum BOQ_FILE_TYPE {
  d11 = 'd11',
  d81 = 'd81',
  d82 = 'd82',
  d83 = 'd83',
  d84 = 'd84',
  d86 = 'd86',
  dta = 'dta',
  onlv = 'onlv',
  p81 = 'p81',
  p82 = 'p82',
  p83 = 'p83',
  p84 = 'p84',
  p86 = 'p86',
  x31 = 'x31',
  x31_33 = 'x31_33',
  x81 = 'x81',
  x81_33 = 'x81_33',
  x82 = 'x82',
  x82_33 = 'x82_33',
  x83 = 'x83',
  x83_33 = 'x83_33',
  x84 = 'x84',
  x84_33 = 'x84_33',
  x86 = 'x86',
  x86_33 = 'x86_33',
  xlsxProposal = 'xlsxProposal',
  xlsxRequestForProposals = 'xlsxRequestForProposals',
}

export enum BOQ_FILE_TYPE_DOWNLOADABLE_FOR_CONTRACT {
  d86 = 'd86',
  p86 = 'p86',
  pdf = 'pdf',
  x86 = 'x86',
  x86_33 = 'x86_33',
}

export enum BOQ_FORMAL_REVIEW_ERROR_REASON {
  additionalTextNotAtBeginningOrEnd = 'additionalTextNotAtBeginningOrEnd',
  currencyDoesntMatchProject = 'currencyDoesntMatchProject',
  currencyNotSupported = 'currencyNotSupported',
  executionDescriptionExist = 'executionDescriptionExist',
  executionDescriptionNotReferencedByAnyPosition = 'executionDescriptionNotReferencedByAnyPosition',
  executionDescriptionNoteWithoutLongText = 'executionDescriptionNoteWithoutLongText',
  executionDescriptionShortTextIsMissing = 'executionDescriptionShortTextIsMissing',
  groupShortTextMissing = 'groupShortTextMissing',
  itemNumberContainsUnderscores = 'itemNumberContainsUnderscores',
  itemNumberDigitsAmountGreaterThan9GAEB90 = 'itemNumberDigitsAmountGreaterThan9GAEB90',
  itemNumberDigitsAmountGreaterThan12OENORM = 'itemNumberDigitsAmountGreaterThan12OENORM',
  itemNumberDigitsAmountGreaterThan14GAEBXML = 'itemNumberDigitsAmountGreaterThan14GAEBXML',
  itemNumberMainFragmentNotPadded = 'itemNumberMainFragmentNotPadded',
  itemNumberMustBeInAscendingOrder = 'itemNumberMustBeInAscendingOrder',
  itemNumberOfGroupIsAlphanumeric = 'itemNumberOfGroupIsAlphanumeric',
  itemNumberOfGroupIsMissing = 'itemNumberOfGroupIsMissing',
  itemNumberOfPositionIsMissing = 'itemNumberOfPositionIsMissing',
  itemNumberOfPositionIsNotUnique = 'itemNumberOfPositionIsNotUnique',
  itemNumberShouldContainParentItemNumber = 'itemNumberShouldContainParentItemNumber',
  longTextHasImage = 'longTextHasImage',
  longTextMissing = 'longTextMissing',
  noteTextShouldBeFirstChildren = 'noteTextShouldBeFirstChildren',
  positionCostGroupReferenceMissing = 'positionCostGroupReferenceMissing',
  positionHasBidderInput = 'positionHasBidderInput',
  positionHasBidderInputInShortText = 'positionHasBidderInputInShortText',
  positionLongTextLongerThan999 = 'positionLongTextLongerThan999',
  positionLongTextMissing = 'positionLongTextMissing',
  positionQuantityDecimalPartLongerThan3 = 'positionQuantityDecimalPartLongerThan3',
  positionQuantityIntegerPartLongerThan8 = 'positionQuantityIntegerPartLongerThan8',
  positionQuantityMissing = 'positionQuantityMissing',
  positionTypesAlternativePositionWithoutBasePosition = 'positionTypesAlternativePositionWithoutBasePosition',
  positionTypesBasePositionWithoutAlternatives = 'positionTypesBasePositionWithoutAlternatives',
  positionTypesLumpSumQuantityCannotBeCombinedWithFreeQuantity = 'positionTypesLumpSumQuantityCannotBeCombinedWithFreeQuantity',
  positionTypesLumpSumQuantityShouldBeOne = 'positionTypesLumpSumQuantityShouldBeOne',
  positionTypesSurchargeHasDifferentTaxRate = 'positionTypesSurchargeHasDifferentTaxRate',
  positionUnitPriceDecimalPartLongerThan3 = 'positionUnitPriceDecimalPartLongerThan3',
  positionUnitPriceIntegerPartLongerThan10 = 'positionUnitPriceIntegerPartLongerThan10',
  positionUnitTagMissing = 'positionUnitTagMissing',
  positionUnitTagNotSupportedByOENORM = 'positionUnitTagNotSupportedByOENORM',
  priceComponentsCountMoreThanExpected = 'priceComponentsCountMoreThanExpected',
  repeatingDescriptionBeforeReferralDescription = 'repeatingDescriptionBeforeReferralDescription',
  repeatingDescriptionNotReferringExistingReferralDescription = 'repeatingDescriptionNotReferringExistingReferralDescription',
  repeatingDescriptionReferringAnotherRepeatingDescription = 'repeatingDescriptionReferringAnotherRepeatingDescription',
  schemaTierCountLessThan3ForOENORM = 'schemaTierCountLessThan3ForOENORM',
  schemaTierCountMoreThan4ForGaeb90 = 'schemaTierCountMoreThan4ForGaeb90',
  schemaTierCountMoreThan5ForGaebXML = 'schemaTierCountMoreThan5ForGaebXML',
  schemaTierCountMoreThan5ForOENORM = 'schemaTierCountMoreThan5ForOENORM',
  schemaTierLengthGreaterThan2OENORM = 'schemaTierLengthGreaterThan2OENORM',
  shortTextMissing = 'shortTextMissing',
  subDescriptionIdentifierNotCompliant = 'subDescriptionIdentifierNotCompliant',
  subDescriptionIdentifierNotInAscendingOrder = 'subDescriptionIdentifierNotInAscendingOrder',
}

export enum BOQ_FORMAL_REVIEW_ISSUE_LEVEL {
  error = 'error',
  warning = 'warning',
}

export enum BOQ_FORMAL_REVIEW_RESULT {
  errors = 'errors',
  noIssues = 'noIssues',
  warnings = 'warnings',
}

export enum BOQ_MASS_DETERMINATION_STATUS {
  appliedAsQuantity = 'appliedAsQuantity',
  savedAsPartOfBoq = 'savedAsPartOfBoq',
}

export enum BOQ_POSITION_TEXT_PROVIDER {
  boqLibrary = 'boqLibrary',
  freeText = 'freeText',
  heinzeAt = 'heinzeAt',
  heinzeVob = 'heinzeVob',
  lbHochbau = 'lbHochbau',
  stlb = 'stlb',
}

export enum BOQ_POSITION_TYPE {
  Alternative = 'Alternative',
  Base = 'Base',
  FreeQuantity = 'FreeQuantity',
  LumpSum = 'LumpSum',
  NotApplicable = 'NotApplicable',
  Optional = 'Optional',
  OptionalWithTotal = 'OptionalWithTotal',
  ReferringExecutionDescription = 'ReferringExecutionDescription',
  Regular = 'Regular',
  RepeatingDescription = 'RepeatingDescription',
  Surcharge = 'Surcharge',
  ToBeSurcharged = 'ToBeSurcharged',
  UnitPriceComponents = 'UnitPriceComponents',
}

export enum BOQ_TEMPLATES_SORT_FIELD {
  name = 'name',
  updatedAt = 'updatedAt',
}

export enum BOQ_TEMPLATE_COST_CATALOG_TYPE {
  custom = 'custom',
  din276 = 'din276',
  oenorm = 'oenorm',
  stlbWorkCategory = 'stlbWorkCategory',
}

export enum BOQ_TIER_DATA_TYPE {
  Alphanumeric = 'Alphanumeric',
  Numeric = 'Numeric',
}

export enum BOQ_TIER_TYPE {
  Group = 'Group',
  Index = 'Index',
  Lot = 'Lot',
  Position = 'Position',
}

export enum BOQ_TYPE {
  addendum = 'addendum',
  customBudget = 'customBudget',
  proposal = 'proposal',
  requestForProposal = 'requestForProposal',
  template = 'template',
}

export enum BOQ_VALIDATION_ERROR_REASON {
  duplicateItemNumber = 'duplicateItemNumber',
  elementRowDoesNotMatchRequestForProposals = 'elementRowDoesNotMatchRequestForProposals',
  elementRowsNotFound = 'elementRowsNotFound',
  itemNumberContainsInvalidCharacters = 'itemNumberContainsInvalidCharacters',
  mergedCells = 'mergedCells',
  notEmptyNorNonNegativeNumber = 'notEmptyNorNonNegativeNumber',
  notEmptyNorNumber = 'notEmptyNorNumber',
  notEmptyNorPercentage = 'notEmptyNorPercentage',
  unknownElementType = 'unknownElementType',
  unrecognizedPositionCostGroup = 'unrecognizedPositionCostGroup',
}

export enum BOQ_VALIDATION_WARNING_REASON {
  doesntExist = 'doesntExist',
  duplicateTextAdditionLabel = 'duplicateTextAdditionLabel',
  notFilledIn = 'notFilledIn',
  positionHasInvalidCostGroupAssigned = 'positionHasInvalidCostGroupAssigned',
  quantitiesDontMatch = 'quantitiesDontMatch',
  quantityMissing = 'quantityMissing',
  quantityNotFilledIn = 'quantityNotFilledIn',
  unknownElementType = 'unknownElementType',
}

export enum BP_PUBLICATION_BID_PACKAGE_DURATION_ISSUE {
  endDateMissing = 'endDateMissing',
  startDateMissing = 'startDateMissing',
}

export enum BP_PUBLICATION_BOQ_INCLUDED_ISSUE {
  hasErrors = 'hasErrors',
  missingSchema = 'missingSchema',
  notProvided = 'notProvided',
}

export enum BP_PUBLICATION_CONTACT_DETAILS_INCLUDED_ISSUE {
  noPhoneUserIsContact = 'noPhoneUserIsContact',
  noPhoneUserIsNotAContact = 'noPhoneUserIsNotAContact',
}

export enum BP_PUBLICATION_DESCRIPTIVE_TENDER_SETUP_ISSUE {
  descriptionSameAsProject = 'descriptionSameAsProject',
  nameAndDescriptionSameAsProject = 'nameAndDescriptionSameAsProject',
  nameSameAsProject = 'nameSameAsProject',
  nameSameAsProjectNoDescription = 'nameSameAsProjectNoDescription',
  shortDescription = 'shortDescription',
}

export enum BP_PUBLICATION_DOCUMENTS_INCLUDED_ISSUE {
  noneUploaded = 'noneUploaded',
}

export enum BP_PUBLICATION_ENABLE_MARKETPLACE {
  notPublishedOnMarketplace = 'notPublishedOnMarketplace',
}

export enum BP_PUBLICATION_OFFICE_DETAILS_INCLUDED_ISSUE {
  notProvided = 'notProvided',
}

export enum BP_PUBLICATION_REASONABLE_BID_DUE_DATE_ISSUE {
  tooSoon = 'tooSoon',
}

export enum BP_PUBLICATION_SUFFICIENT_NUMBER_OF_BIDDERS_ISSUE {
  insufficient = 'insufficient',
}

export enum BULK_ADD_CONTACTS_AMOUNT {
  x10 = 'x10',
  x25 = 'x25',
  x50 = 'x50',
}

export enum BidAuthActions {
  manageDocuments = 'manageDocuments',
  signContract = 'signContract',
  update = 'update',
  update__message = 'update__message',
  view = 'view',
}

export enum BidInviteAuthActions {
  delete = 'delete',
  view = 'view',
  withdraw = 'withdraw',
}

export enum BidPackageAuthActions {
  addContacts = 'addContacts',
  close = 'close',
  createAddendum = 'createAddendum',
  createInvoice = 'createInvoice',
  createOrUpdateBoQ = 'createOrUpdateBoQ',
  createOrUpdateCalculationBoQ = 'createOrUpdateCalculationBoQ',
  delete = 'delete',
  deleteBoQ = 'deleteBoQ',
  duplicate = 'duplicate',
  manageInternalNotes = 'manageInternalNotes',
  modifyMarketplacePublicationConfig = 'modifyMarketplacePublicationConfig',
  openBlindTenderBids = 'openBlindTenderBids',
  openBlindTenderBidsApprove = 'openBlindTenderBidsApprove',
  predictPrices = 'predictPrices',
  prepareContract = 'prepareContract',
  previewMarketplaceSuggestion = 'previewMarketplaceSuggestion',
  printBoQ = 'printBoQ',
  publish = 'publish',
  publishApprove = 'publishApprove',
  reopen = 'reopen',
  restartBlindTender = 'restartBlindTender',
  sendMarketplaceSuggestions = 'sendMarketplaceSuggestions',
  sendMessage = 'sendMessage',
  simulatePriceComparison = 'simulatePriceComparison',
  submitContract = 'submitContract',
  submitContractApprove = 'submitContractApprove',
  update = 'update',
  updateBoQInternalNote = 'updateBoQInternalNote',
  update__internalData = 'update__internalData',
  uploadContractAgentSignature = 'uploadContractAgentSignature',
  uploadInternalDocuments = 'uploadInternalDocuments',
  uploadSharedDocuments = 'uploadSharedDocuments',
  view = 'view',
  viewMarketplaceList = 'viewMarketplaceList',
  viewOnMarketplace = 'viewOnMarketplace',
  view__documents = 'view__documents',
  view__internalData = 'view__internalData',
  view__messages = 'view__messages',
  view__priceComparison = 'view__priceComparison',
  view__priceComparisonDownloadUrl = 'view__priceComparisonDownloadUrl',
  view__reportingData = 'view__reportingData',
  withdrawContract = 'withdrawContract',
}

export enum BidRequestAuthActions {
  award = 'award',
  awardApprove = 'awardApprove',
  createNote = 'createNote',
  delete = 'delete',
  deleteBid = 'deleteBid',
  deleteNote = 'deleteNote',
  manageTasks = 'manageTasks',
  negotiate = 'negotiate',
  rate = 'rate',
  reject = 'reject',
  sendAwardingEmail = 'sendAwardingEmail',
  sendInvite = 'sendInvite',
  submit = 'submit',
  submitBid = 'submitBid',
  unAward = 'unAward',
  unReject = 'unReject',
  update = 'update',
  updateAgentStatus = 'updateAgentStatus',
  updateStatus = 'updateStatus',
  update__customBidsDueAt = 'update__customBidsDueAt',
  uploadBidBoQ = 'uploadBidBoQ',
  view = 'view',
}

export enum BillOfQuantitiesAuthActions {
  downloadRequestForProposalPdf = 'downloadRequestForProposalPdf',
  update = 'update',
}

export enum CERTIFICATE_AVAILABILITY {
  available = 'available',
  expired = 'expired',
  expiringSoon = 'expiringSoon',
  notAvailable = 'notAvailable',
}

export enum CERTIFICATE_FILE_TYPE {
  jpeg = 'jpeg',
  pdf = 'pdf',
  png = 'png',
  xls = 'xls',
  xlsx = 'xlsx',
}

export enum CERTIFICATE_REQUESTS_SORT_FIELD {
  company = 'company',
  dueDate = 'dueDate',
  requestedOn = 'requestedOn',
  status = 'status',
  statusForAgent = 'statusForAgent',
}

export enum CERTIFICATE_REQUEST_STATUS {
  pending = 'pending',
  rejected = 'rejected',
  submitted = 'submitted',
  withdrawn = 'withdrawn',
}

export enum CERTIFICATE_REQUEST_STATUS_FOR_AGENT {
  done = 'done',
  incomplete = 'incomplete',
  overdue = 'overdue',
  rejected = 'rejected',
}

export enum CERTIFICATE_STATUS {
  draft = 'draft',
  submitted = 'submitted',
}

export enum CERTIFICATE_TYPE_SCOPE {
  bidPackage = 'bidPackage',
  universal = 'universal',
}

export enum CERTIFICATE_TYPE_STATUS {
  available = 'available',
  expired = 'expired',
  expiringSoon = 'expiringSoon',
  notAvailable = 'notAvailable',
  rejected = 'rejected',
  requested = 'requested',
}

export enum CERTIFICATE_TYPE_TYPE {
  company = 'company',
  global = 'global',
}

export enum COMPANIES_SORT_FIELD {
  createdAt = 'createdAt',
  name = 'name',
}

export enum COMPANY_SIZE {
  size_1_4 = 'size_1_4',
  size_5_9 = 'size_5_9',
  size_10_19 = 'size_10_19',
  size_20_49 = 'size_20_49',
  size_50_99 = 'size_50_99',
  size_100_199 = 'size_100_199',
  size_200_499 = 'size_200_499',
  size_500plus = 'size_500plus',
}

export enum COMPANY_TEMPLATE_SORT_FIELD {
  name = 'name',
}

export enum COMPANY_TEMPLATE_TYPE {
  awarding = 'awarding',
  bidInviteIntroAwardProject = 'bidInviteIntroAwardProject',
  bidInviteIntroEstimateProject = 'bidInviteIntroEstimateProject',
  bidPackageClosed = 'bidPackageClosed',
  bidderIntroduction = 'bidderIntroduction',
  message = 'message',
  rejection = 'rejection',
}

export enum COMPANY_TYPE {
  agent = 'agent',
  principal = 'principal',
}

export enum CONTACT_SUGGESTION_CHANGE_TYPE {
  create = 'create',
  update = 'update',
}

export enum CONTACT_SUGGESTION_FIELDS_CHANGE_TYPE {
  append = 'append',
  remove = 'remove',
  set = 'set',
  unset = 'unset',
}

export enum CONTACT_SUGGESTION_FIELDS_FIELD_NAME {
  email = 'email',
  fax = 'fax',
  firstName = 'firstName',
  isPerson = 'isPerson',
  jobTitle = 'jobTitle',
  lastName = 'lastName',
  mobilePhone = 'mobilePhone',
  phone = 'phone',
  title = 'title',
}

export enum CONTACT_SUGGESTION_FIELDS_REVIEW_RESULT {
  approved = 'approved',
  dismissed = 'dismissed',
}

export enum CONTACT_TITLE {
  mr = 'mr',
  ms = 'ms',
}

export enum CONTRACT_REMINDER_SCHEDULE {
  everyTwoWeeks = 'everyTwoWeeks',
  none = 'none',
  weekly = 'weekly',
}

export enum COST_ANALYSIS_BREAKDOWN {
  bidPackage = 'bidPackage',
  custom = 'custom',
  din276 = 'din276',
  oenorm = 'oenorm',
  stlbWorkCategory = 'stlbWorkCategory',
}

export enum COST_ANALYSIS_TOP_LEVEL_GROUPING {
  bidPackage = 'bidPackage',
  project = 'project',
}

export enum COST_CATALOG_TYPE {
  bidPackage = 'bidPackage',
  custom = 'custom',
  din276 = 'din276',
  oenorm = 'oenorm',
  stlbWorkCategory = 'stlbWorkCategory',
}

export enum COST_GROUP_TYPE {
  din276 = 'din276',
  oenorm = 'oenorm',
}

export enum COUNTRY_CODE {
  AD = 'AD',
  AE = 'AE',
  AF = 'AF',
  AG = 'AG',
  AI = 'AI',
  AL = 'AL',
  AM = 'AM',
  AO = 'AO',
  AQ = 'AQ',
  AR = 'AR',
  AS = 'AS',
  AT = 'AT',
  AU = 'AU',
  AW = 'AW',
  AX = 'AX',
  AZ = 'AZ',
  BA = 'BA',
  BB = 'BB',
  BD = 'BD',
  BE = 'BE',
  BF = 'BF',
  BG = 'BG',
  BH = 'BH',
  BI = 'BI',
  BJ = 'BJ',
  BL = 'BL',
  BM = 'BM',
  BN = 'BN',
  BO = 'BO',
  BQ = 'BQ',
  BR = 'BR',
  BS = 'BS',
  BT = 'BT',
  BV = 'BV',
  BW = 'BW',
  BY = 'BY',
  BZ = 'BZ',
  CA = 'CA',
  CC = 'CC',
  CD = 'CD',
  CF = 'CF',
  CG = 'CG',
  CH = 'CH',
  CI = 'CI',
  CK = 'CK',
  CL = 'CL',
  CM = 'CM',
  CN = 'CN',
  CO = 'CO',
  CR = 'CR',
  CU = 'CU',
  CV = 'CV',
  CW = 'CW',
  CX = 'CX',
  CY = 'CY',
  CZ = 'CZ',
  DE = 'DE',
  DJ = 'DJ',
  DK = 'DK',
  DM = 'DM',
  DO = 'DO',
  DZ = 'DZ',
  EC = 'EC',
  EE = 'EE',
  EG = 'EG',
  EH = 'EH',
  ER = 'ER',
  ES = 'ES',
  ET = 'ET',
  FI = 'FI',
  FJ = 'FJ',
  FK = 'FK',
  FM = 'FM',
  FO = 'FO',
  FR = 'FR',
  GA = 'GA',
  GB = 'GB',
  GD = 'GD',
  GE = 'GE',
  GF = 'GF',
  GG = 'GG',
  GH = 'GH',
  GI = 'GI',
  GL = 'GL',
  GM = 'GM',
  GN = 'GN',
  GP = 'GP',
  GQ = 'GQ',
  GR = 'GR',
  GS = 'GS',
  GT = 'GT',
  GU = 'GU',
  GW = 'GW',
  GY = 'GY',
  HK = 'HK',
  HM = 'HM',
  HN = 'HN',
  HR = 'HR',
  HT = 'HT',
  HU = 'HU',
  ID = 'ID',
  IE = 'IE',
  IL = 'IL',
  IM = 'IM',
  IN = 'IN',
  IO = 'IO',
  IQ = 'IQ',
  IR = 'IR',
  IS = 'IS',
  IT = 'IT',
  JE = 'JE',
  JM = 'JM',
  JO = 'JO',
  JP = 'JP',
  KE = 'KE',
  KG = 'KG',
  KH = 'KH',
  KI = 'KI',
  KM = 'KM',
  KN = 'KN',
  KP = 'KP',
  KR = 'KR',
  KW = 'KW',
  KY = 'KY',
  KZ = 'KZ',
  LA = 'LA',
  LB = 'LB',
  LC = 'LC',
  LI = 'LI',
  LK = 'LK',
  LR = 'LR',
  LS = 'LS',
  LT = 'LT',
  LU = 'LU',
  LV = 'LV',
  LY = 'LY',
  MA = 'MA',
  MC = 'MC',
  MD = 'MD',
  ME = 'ME',
  MF = 'MF',
  MG = 'MG',
  MH = 'MH',
  MK = 'MK',
  ML = 'ML',
  MM = 'MM',
  MN = 'MN',
  MO = 'MO',
  MP = 'MP',
  MQ = 'MQ',
  MR = 'MR',
  MS = 'MS',
  MT = 'MT',
  MU = 'MU',
  MV = 'MV',
  MW = 'MW',
  MX = 'MX',
  MY = 'MY',
  MZ = 'MZ',
  NA = 'NA',
  NC = 'NC',
  NE = 'NE',
  NF = 'NF',
  NG = 'NG',
  NI = 'NI',
  NL = 'NL',
  NO = 'NO',
  NP = 'NP',
  NR = 'NR',
  NU = 'NU',
  NZ = 'NZ',
  OM = 'OM',
  PA = 'PA',
  PE = 'PE',
  PF = 'PF',
  PG = 'PG',
  PH = 'PH',
  PK = 'PK',
  PL = 'PL',
  PM = 'PM',
  PN = 'PN',
  PR = 'PR',
  PS = 'PS',
  PT = 'PT',
  PW = 'PW',
  PY = 'PY',
  QA = 'QA',
  RE = 'RE',
  RO = 'RO',
  RS = 'RS',
  RU = 'RU',
  RW = 'RW',
  SA = 'SA',
  SB = 'SB',
  SC = 'SC',
  SD = 'SD',
  SE = 'SE',
  SG = 'SG',
  SH = 'SH',
  SI = 'SI',
  SJ = 'SJ',
  SK = 'SK',
  SL = 'SL',
  SM = 'SM',
  SN = 'SN',
  SO = 'SO',
  SR = 'SR',
  SS = 'SS',
  ST = 'ST',
  SV = 'SV',
  SX = 'SX',
  SY = 'SY',
  SZ = 'SZ',
  TC = 'TC',
  TD = 'TD',
  TF = 'TF',
  TG = 'TG',
  TH = 'TH',
  TJ = 'TJ',
  TK = 'TK',
  TL = 'TL',
  TM = 'TM',
  TN = 'TN',
  TO = 'TO',
  TR = 'TR',
  TT = 'TT',
  TV = 'TV',
  TW = 'TW',
  TZ = 'TZ',
  UA = 'UA',
  UG = 'UG',
  UM = 'UM',
  US = 'US',
  UY = 'UY',
  UZ = 'UZ',
  VA = 'VA',
  VC = 'VC',
  VE = 'VE',
  VG = 'VG',
  VI = 'VI',
  VN = 'VN',
  VU = 'VU',
  WF = 'WF',
  WS = 'WS',
  XK = 'XK',
  YE = 'YE',
  YT = 'YT',
  ZA = 'ZA',
  ZM = 'ZM',
  ZW = 'ZW',
}

export enum CURRENCY {
  ALL = 'ALL',
  AMD = 'AMD',
  AZN = 'AZN',
  BAM = 'BAM',
  BGN = 'BGN',
  BYN = 'BYN',
  CHF = 'CHF',
  CZK = 'CZK',
  DKK = 'DKK',
  EUR = 'EUR',
  GBP = 'GBP',
  GEL = 'GEL',
  HRK = 'HRK',
  HUF = 'HUF',
  ISK = 'ISK',
  MDL = 'MDL',
  MKD = 'MKD',
  NOK = 'NOK',
  PLN = 'PLN',
  RON = 'RON',
  RSD = 'RSD',
  RUB = 'RUB',
  SEK = 'SEK',
  TRY = 'TRY',
  UAH = 'UAH',
}

export enum CUSTOM_COST_GROUP_CATALOGS_SORT_FIELD {
  name = 'name',
}

export enum CUSTOM_COST_GROUP_CATALOG_STATUS {
  active = 'active',
  deactivated = 'deactivated',
}

export enum CUSTOM_EMAIL_VALIDATION_RESULT {
  failed = 'failed',
  pending = 'pending',
  validated = 'validated',
}

export enum CUSTOM_FIELD_ENTITY_TYPE {
  project = 'project',
  subcontractor = 'subcontractor',
}

export enum CUSTOM_FIELD_TYPE {
  checkbox = 'checkbox',
  currency = 'currency',
  date = 'date',
  dateTime = 'dateTime',
  multiSelect = 'multiSelect',
  number = 'number',
  singleSelect = 'singleSelect',
  text = 'text',
}

export enum CertificateAuthActions {
  delete = 'delete',
  publish = 'publish',
  update = 'update',
  view = 'view',
}

export enum CertificateTypeAuthActions {
  cancelCertificateRequest = 'cancelCertificateRequest',
  createCertificate = 'createCertificate',
  createGlobalCertificateType = 'createGlobalCertificateType',
  delete = 'delete',
  select = 'select',
  sendCertificateRequest = 'sendCertificateRequest',
  update = 'update',
  view = 'view',
}

export enum CertificateTypeTranslationAuthActions {
  update = 'update',
}

export enum CompanyAuthActions {
  create = 'create',
  createAgentBidRequest = 'createAgentBidRequest',
  createAgentCertificateType = 'createAgentCertificateType',
  createCompanyCertificateType = 'createCompanyCertificateType',
  createCompanySubcontractor = 'createCompanySubcontractor',
  createCompanyTemplate = 'createCompanyTemplate',
  createCustomCostGroupCatalog = 'createCustomCostGroupCatalog',
  createNetworkSubcontractor = 'createNetworkSubcontractor',
  createOffice = 'createOffice',
  createOrUpdateBoQTemplate = 'createOrUpdateBoQTemplate',
  createSubcontractorImportRequests = 'createSubcontractorImportRequests',
  createTask = 'createTask',
  createTerms = 'createTerms',
  deleteBoQTemplate = 'deleteBoQTemplate',
  deleteSubcontractorImportRequests = 'deleteSubcontractorImportRequests',
  exportSubcontractors = 'exportSubcontractors',
  generateUploadUrlForSubcontractorsImport = 'generateUploadUrlForSubcontractorsImport',
  inviteUsers = 'inviteUsers',
  managePermissions = 'managePermissions',
  merge = 'merge',
  requestProfileCompletion = 'requestProfileCompletion',
  sendInviteRequests = 'sendInviteRequests',
  sendPremiumPurchaseRequest = 'sendPremiumPurchaseRequest',
  startTrial__costEstimationAndControlling = 'startTrial__costEstimationAndControlling',
  startTrial__individualisation = 'startTrial__individualisation',
  update = 'update',
  updateSubcontractorImportRequests = 'updateSubcontractorImportRequests',
  update__featureFlags = 'update__featureFlags',
  uploadInternalDocuments = 'uploadInternalDocuments',
  usePriceLibrary = 'usePriceLibrary',
  view = 'view',
  viewUsers = 'viewUsers',
  view__allOfficeProjects = 'view__allOfficeProjects',
  view__allUsersBidPackages = 'view__allUsersBidPackages',
  view__certificates = 'view__certificates',
  view__claimedSubcontractors = 'view__claimedSubcontractors',
  view__contacts = 'view__contacts',
  view__externalApiAccessKey = 'view__externalApiAccessKey',
  view__internalDocuments = 'view__internalDocuments',
  view__prefill = 'view__prefill',
  view__subcontractorImportRequests = 'view__subcontractorImportRequests',
  view__subcontractors = 'view__subcontractors',
}

export enum CompanySubcontractorsImportAuthActions {
  process = 'process',
  view = 'view',
}

export enum CompanyTemplateAuthActions {
  delete = 'delete',
  update = 'update',
  view = 'view',
}

export enum ContactAuthActions {
  suggestChanges = 'suggestChanges',
  update = 'update',
  update__notificationConfig = 'update__notificationConfig',
  view = 'view',
  view__notificationConfig = 'view__notificationConfig',
}

export enum CustomCostGroupCatalogAuthActions {
  update = 'update',
  view = 'view',
}

export enum DEPARTMENT_TYPE {
  architect = 'architect',
  calculation = 'calculation',
  client = 'client',
  constructionManagement = 'constructionManagement',
  managementBoard = 'managementBoard',
  other = 'other',
  preparationBackOffice = 'preparationBackOffice',
  projectManagement = 'projectManagement',
  purchasing = 'purchasing',
  specialistPlanning = 'specialistPlanning',
  technical = 'technical',
}

export enum DISCOUNT_METHOD {
  absolute = 'absolute',
  percentage = 'percentage',
}

export enum DOCUMENT_ENTITY {
  Addendum = 'Addendum',
  Bid = 'Bid',
  BidPackage = 'BidPackage',
  BidPackageInternal = 'BidPackageInternal',
  BidRequestInNegotiation = 'BidRequestInNegotiation',
  Company = 'Company',
  Contract = 'Contract',
  ContractBoQ = 'ContractBoQ',
  InitialContract = 'InitialContract',
  Project = 'Project',
  ProjectBim = 'ProjectBim',
  ProjectInternal = 'ProjectInternal',
}

export enum EDITING_SESSION_TYPE {
  bidPackageBoqEditor = 'bidPackageBoqEditor',
  boqTemplateBoqEditor = 'boqTemplateBoqEditor',
  priceComparisonSimulationMode = 'priceComparisonSimulationMode',
  projectCostEstimation = 'projectCostEstimation',
}

export enum EMAIL_SALUTATION_MODE {
  autoPrepend = 'autoPrepend',
  editable = 'editable',
}

export enum EMAIL_STATUS {
  blocked = 'blocked',
  bounced = 'bounced',
  clicked = 'clicked',
  delivered = 'delivered',
  failed = 'failed',
  opened = 'opened',
  pending = 'pending',
  queued = 'queued',
  reportedAsSpam = 'reportedAsSpam',
  unsubscribed = 'unsubscribed',
}

export enum EMAIL_TEMPLATES {
  AdminInvite = 'AdminInvite',
  AdminResetPassword = 'AdminResetPassword',
  AgentSignupConfirmation = 'AgentSignupConfirmation',
  AgentSignupReminder = 'AgentSignupReminder',
  AgentUpdateProfileReminder = 'AgentUpdateProfileReminder',
  AgentUserInvite = 'AgentUserInvite',
  AgentUserInviteReminder = 'AgentUserInviteReminder',
  BidConfirmation = 'BidConfirmation',
  BidConfirmationAfterPrincipalSubmission = 'BidConfirmationAfterPrincipalSubmission',
  BidInvite = 'BidInvite',
  BidInviteReminder = 'BidInviteReminder',
  BidInvitesFailed = 'BidInvitesFailed',
  BidNotification = 'BidNotification',
  BidPackageChangedNotification = 'BidPackageChangedNotification',
  BidPackageClosed = 'BidPackageClosed',
  BidPackageExportBidsNotification = 'BidPackageExportBidsNotification',
  BidPackageStatusChangedNotification = 'BidPackageStatusChangedNotification',
  BidRequestAwardedNotification = 'BidRequestAwardedNotification',
  BidRequestDeclined = 'BidRequestDeclined',
  BidRequestRejectedNotification = 'BidRequestRejectedNotification',
  BidderIntroduction = 'BidderIntroduction',
  BiddersAwaitingResponse = 'BiddersAwaitingResponse',
  BiddingPeriodEnding = 'BiddingPeriodEnding',
  BoQChangedNotification = 'BoQChangedNotification',
  CertificateExpiring = 'CertificateExpiring',
  CertificateNotProvidedInTime = 'CertificateNotProvidedInTime',
  CertificateRequest = 'CertificateRequest',
  CertificatesRejectedNotification = 'CertificatesRejectedNotification',
  CertificatesUploadedNotification = 'CertificatesUploadedNotification',
  ContactSignupSuggestion = 'ContactSignupSuggestion',
  ContractAgentRequest = 'ContractAgentRequest',
  ContractSignature = 'ContractSignature',
  ContractWithdrawn = 'ContractWithdrawn',
  DocumentNotification = 'DocumentNotification',
  ExportFailed = 'ExportFailed',
  ExternalBidNotification = 'ExternalBidNotification',
  InvoiceApprovalRequired = 'InvoiceApprovalRequired',
  InvoiceForward = 'InvoiceForward',
  MarketplaceBidRequestBidsDueNotification = 'MarketplaceBidRequestBidsDueNotification',
  MarketplaceSuggestion = 'MarketplaceSuggestion',
  MarketplaceTenderClosedNotification = 'MarketplaceTenderClosedNotification',
  MfaResetNotice = 'MfaResetNotice',
  MfaResetRequest = 'MfaResetRequest',
  MfaSetupNotice = 'MfaSetupNotice',
  MultiUserApprovalRequest = 'MultiUserApprovalRequest',
  MultipleMarketplaceSuggestions = 'MultipleMarketplaceSuggestions',
  NewMessageNotification = 'NewMessageNotification',
  PasswordlessLogin = 'PasswordlessLogin',
  ProjectExportComplete = 'ProjectExportComplete',
  PublishMarketplaceRestrictedView = 'PublishMarketplaceRestrictedView',
  ReportAgentCompanyClosed = 'ReportAgentCompanyClosed',
  RequestProfileCompletion = 'RequestProfileCompletion',
  ResetPassword = 'ResetPassword',
  SalesforceAgentUnsolicitedSignupEmail = 'SalesforceAgentUnsolicitedSignupEmail',
  SalesforceNewCompanyContactImportRequest = 'SalesforceNewCompanyContactImportRequest',
  SavedSearchNotification = 'SavedSearchNotification',
  SignupConfirmation = 'SignupConfirmation',
  SignupDenial = 'SignupDenial',
  SignupSubcontractorConfirmation = 'SignupSubcontractorConfirmation',
  StaleBidPackageDraftReminder = 'StaleBidPackageDraftReminder',
  SubcontractorImportRequestCompleted = 'SubcontractorImportRequestCompleted',
  TaskAssigned = 'TaskAssigned',
  TaskCompleted = 'TaskCompleted',
  TaskInProgress = 'TaskInProgress',
  TaskReminder = 'TaskReminder',
  TrialEndingSoon = 'TrialEndingSoon',
  TrialFeedback = 'TrialFeedback',
  TrialStarting = 'TrialStarting',
  UserAddedToBidPackageTeam = 'UserAddedToBidPackageTeam',
  UserAddedToMultipleBidPackageTeams = 'UserAddedToMultipleBidPackageTeams',
  UserInvite = 'UserInvite',
  UserInviteReminder = 'UserInviteReminder',
  UserInviteRequest = 'UserInviteRequest',
  UserInvitesFailed = 'UserInvitesFailed',
  UserJoinRequest = 'UserJoinRequest',
  UserLocked = 'UserLocked',
  UserPasswordOutdatedSoon = 'UserPasswordOutdatedSoon',
  UserSignupsUncompleted = 'UserSignupsUncompleted',
  UserWelcome = 'UserWelcome',
}

export enum EMAIL_VALIDATION_STATUS {
  invalidDomain = 'invalidDomain',
  invalidFormat = 'invalidFormat',
  unknown = 'unknown',
  used = 'used',
  valid = 'valid',
}

export enum EXPERIMENT_NAME {
  dataAnalyticsUpsell = 'dataAnalyticsUpsell',
  data_analytics_upsell = 'data_analytics_upsell',
  experimentAlwaysPublishTendersOnTheMarketplace = 'experimentAlwaysPublishTendersOnTheMarketplace',
  experimentCheckboxForMarketplacePublishing = 'experimentCheckboxForMarketplacePublishing',
  experimentGoldPackageOnePager = 'experimentGoldPackageOnePager',
  experimentInContextHintsReverseTrial = 'experimentInContextHintsReverseTrial',
  experimentMarketplaceLockSpecialOffer = 'experimentMarketplaceLockSpecialOffer',
  experimentMarketplacePromptWhenSwitchingOff = 'experimentMarketplacePromptWhenSwitchingOff',
  experimentPublishRestrictedBidPackageViewOnMarketplace = 'experimentPublishRestrictedBidPackageViewOnMarketplace',
  experimentShowAiPredictedBidPackageContractValue = 'experimentShowAiPredictedBidPackageContractValue',
  experimentUpsellHintInRmList = 'experimentUpsellHintInRmList',
  experiment_always_publish_tenders_on_the_marketplace = 'experiment_always_publish_tenders_on_the_marketplace',
  experiment_checkbox_for_marketplace_publishing = 'experiment_checkbox_for_marketplace_publishing',
  experiment_gold_package_one_pager = 'experiment_gold_package_one_pager',
  experiment_in_context_hints_reverse_trial = 'experiment_in_context_hints_reverse_trial',
  experiment_marketplace_lock_special_offer = 'experiment_marketplace_lock_special_offer',
  experiment_marketplace_prompt_when_switching_off = 'experiment_marketplace_prompt_when_switching_off',
  experiment_publish_restricted_bid_package_view_on_marketplace = 'experiment_publish_restricted_bid_package_view_on_marketplace',
  experiment_show_ai_predicted_bid_package_contract_value = 'experiment_show_ai_predicted_bid_package_contract_value',
  experiment_upsell_hint_in_rm_list = 'experiment_upsell_hint_in_rm_list',
  releaseBidderInviteRecommendations = 'releaseBidderInviteRecommendations',
  releaseRestrictNetworkInvitesIfAwaitingFeedback = 'releaseRestrictNetworkInvitesIfAwaitingFeedback',
  releaseWarnBeforeInvitingBidderAwaitingFeedback = 'releaseWarnBeforeInvitingBidderAwaitingFeedback',
  release_bidder_invite_recommendations = 'release_bidder_invite_recommendations',
  release_restrict_network_invites_if_awaiting_feedback = 'release_restrict_network_invites_if_awaiting_feedback',
  release_warn_before_inviting_bidder_awaiting_feedback = 'release_warn_before_inviting_bidder_awaiting_feedback',
}

export enum EXTERNAL_CREDENTIAL_TYPE {
  heinzeVob = 'heinzeVob',
  stlb = 'stlb',
}

export enum ExternalCredentialAuthActions {
  update = 'update',
  view = 'view',
}

export enum HighlightPriceMode {
  extremes = 'extremes',
  outliers = 'outliers',
}

export enum IMPORTABLE_BOQ_FIELD {
  customCostCatalog = 'customCostCatalog',
  descriptionLong = 'descriptionLong',
  descriptionShort = 'descriptionShort',
  din276 = 'din276',
  itemNumber = 'itemNumber',
  oenorm = 'oenorm',
  positionType = 'positionType',
  quantity = 'quantity',
  stlbWorkCategory = 'stlbWorkCategory',
  taxRate = 'taxRate',
  timeTracking = 'timeTracking',
  totalPrice = 'totalPrice',
  totalPriceGross = 'totalPriceGross',
  unitPrice = 'unitPrice',
  unitPriceComponent = 'unitPriceComponent',
  unitTag = 'unitTag',
}

export enum INVITE_REQUEST_SOURCE_TYPE {
  bidPackageUsers = 'bidPackageUsers',
  projectBillingRunUsers = 'projectBillingRunUsers',
  projectUsers = 'projectUsers',
}

export enum INVOICE_CUSTOM_ROW_TYPE {
  absolute = 'absolute',
  percent = 'percent',
}

export enum INVOICE_HISTORY_STATUS {
  approved = 'approved',
  modified = 'modified',
  rejected = 'rejected',
  rejectedAndReturnedForAdjustments = 'rejectedAndReturnedForAdjustments',
}

export enum INVOICE_SORT_FIELD {
  bidPackageName = 'bidPackageName',
  numberExternal = 'numberExternal',
  status = 'status',
}

export enum INVOICE_STATUS {
  approvalPending = 'approvalPending',
  approved = 'approved',
  paid = 'paid',
  paymentInProgress = 'paymentInProgress',
  rejected = 'rejected',
}

export enum InvoiceAuthActions {
  createInvoiceNote = 'createInvoiceNote',
  delete = 'delete',
  update = 'update',
  view = 'view',
}

export enum LANGUAGE {
  bg = 'bg',
  cs = 'cs',
  da = 'da',
  de = 'de',
  el = 'el',
  en = 'en',
  es = 'es',
  et = 'et',
  fi = 'fi',
  fr = 'fr',
  hr = 'hr',
  hu = 'hu',
  it = 'it',
  lt = 'lt',
  lv = 'lv',
  nl = 'nl',
  pl = 'pl',
  pt = 'pt',
  ro = 'ro',
  sk = 'sk',
  sv = 'sv',
}

export enum LONG_RUNNING_TASK_STATE {
  completed = 'completed',
  failed = 'failed',
  pending = 'pending',
}

export enum MAILJET_EVENT_TYPE {
  blocked = 'blocked',
  bounce = 'bounce',
  click = 'click',
  open = 'open',
  sent = 'sent',
  spam = 'spam',
  unsub = 'unsub',
}

export enum MAILJET_MESSAGE_STATUS {
  blocked = 'blocked',
  bounce = 'bounce',
  clicked = 'clicked',
  deferred = 'deferred',
  hardbounced = 'hardbounced',
  opened = 'opened',
  queued = 'queued',
  sent = 'sent',
  softbounced = 'softbounced',
  spam = 'spam',
  unknown = 'unknown',
  unsub = 'unsub',
}

export enum MARKETPLACE_BID_REQUEST_STATUS {
  accepted = 'accepted',
  undecided = 'undecided',
  watched = 'watched',
}

export enum MARKETPLACE_SUGGESTIONS_SORT_FIELD {
  sentAt = 'sentAt',
}

export enum MARKETPLACE_SUGGESTION_STATUS {
  bidSubmitted = 'bidSubmitted',
  draft = 'draft',
  failed = 'failed',
  opened = 'opened',
  sent = 'sent',
  viewed = 'viewed',
}

export enum MESSAGE_THREAD_SORT_FIELD {
  lastMessageCreatedAt = 'lastMessageCreatedAt',
}

export enum MFA_METHOD {
  authenticator = 'authenticator',
  phone = 'phone',
}

export enum MULTI_USER_APPROVAL_ACTION {
  approveAddendum = 'approveAddendum',
  awardBid = 'awardBid',
  openBids = 'openBids',
  publishBidPackage = 'publishBidPackage',
  sendContract = 'sendContract',
}

export enum MarketplaceSuggestionAuthActions {
  view = 'view',
}

export enum NETWORK_SUBCONTRACTOR_IMPORT_GENERAL_VALIDATION_CONSTRAINT {
  empty = 'empty',
  invalid = 'invalid',
}

export enum NETWORK_SUBCONTRACTOR_IMPORT_HEADER_VALIDATION_CONSTRAINT {
  missingColumns = 'missingColumns',
  unknownColumns = 'unknownColumns',
}

export enum NETWORK_SUBCONTRACTOR_IMPORT_OPERATION {
  create = 'create',
  update = 'update',
  upsert = 'upsert',
}

export enum NETWORK_SUBCONTRACTOR_IMPORT_RELATIONS_STRATEGY {
  appendOnly = 'appendOnly',
  override = 'override',
}

export enum NETWORK_SUBCONTRACTOR_IMPORT_ROW_VALIDATION_CONSTRAINT {
  deleted = 'deleted',
  invalidType = 'invalidType',
  invalidValue = 'invalidValue',
  missingIdentifier = 'missingIdentifier',
  missingProperties = 'missingProperties',
  notFound = 'notFound',
}

export enum NETWORK_SUBCONTRACTOR_IMPORT_STATUS {
  created = 'created',
  processing = 'processing',
  processingCompleted = 'processingCompleted',
  validationFailed = 'validationFailed',
  validationSuccessful = 'validationSuccessful',
}

export enum OFFICE_DEFAULT_MARKETPLACE_OPTIONS {
  disabled = 'disabled',
  enabled = 'enabled',
  forced = 'forced',
}

export enum OFFICE_REQUIRE_TERMS_OPTION {
  none = 'none',
  requiredAlways = 'requiredAlways',
  requiredPerProject = 'requiredPerProject',
}

export enum OFFICE_STATUS {
  active = 'active',
  inactive = 'inactive',
}

export enum ORDER_AREA_TYPE {
  country = 'country',
  radius = 'radius',
  state = 'state',
  worldwide = 'worldwide',
}

export enum ORDER_RADIUS {
  km_20 = 'km_20',
  km_50 = 'km_50',
  km_100 = 'km_100',
  km_200 = 'km_200',
  km_350 = 'km_350',
  km_500 = 'km_500',
  km_750 = 'km_750',
  km_1000 = 'km_1000',
  km_2000 = 'km_2000',
  km_3000 = 'km_3000',
  unlimited = 'unlimited',
}

export enum ORIENTATION {
  landscape = 'landscape',
  portrait = 'portrait',
}

export enum OfficeAuthActions {
  createProject = 'createProject',
  createTerms = 'createTerms',
  deactivateOrReactivate = 'deactivateOrReactivate',
  delete = 'delete',
  update = 'update',
  view = 'view',
}

export enum PARSED_IFC_FILE_AUTODESK_PROCESSING_STATE {
  error = 'error',
  pending = 'pending',
  success = 'success',
}

export enum PARSED_IFC_FILE_NODE_BASE_QUANTITY_TYPE {
  crossSectionArea = 'crossSectionArea',
  grossArea = 'grossArea',
  grossFootprintArea = 'grossFootprintArea',
  grossVolume = 'grossVolume',
  length = 'length',
  netArea = 'netArea',
  netVolume = 'netVolume',
  netWeight = 'netWeight',
  outerSurfaceArea = 'outerSurfaceArea',
  width = 'width',
}

export enum PREMIUM_ENABLED_REASON {
  organization = 'organization',
  subscription = 'subscription',
}

export enum PRICE_LIBRARY_BOQ_ELEMENT_TYPE {
  note = 'note',
  position = 'position',
}

export enum PRICE_LIBRARY_POSITIONS_SORT_FIELD {
  submittedAt = 'submittedAt',
}

export enum PRICE_PREDICTION_CONTEXT {
  pct = 'pct',
  proposalDraft = 'proposalDraft',
  requestForProposals = 'requestForProposals',
  requestForProposalsDraft = 'requestForProposalsDraft',
}

export enum PRICE_PREDICTION_EVALUATION_STATUS {
  high = 'high',
  low = 'low',
  noPrice = 'noPrice',
  within = 'within',
}

export enum PRICE_PREDICTION_RANGE {
  high = 'high',
  low = 'low',
  medium = 'medium',
}

export enum PRICING_ADD_ON {
  ai = 'ai',
  analytics = 'analytics',
}

export enum PRICING_PLAN {
  bronze = 'bronze',
  enterprise = 'enterprise',
  gold = 'gold',
  silver = 'silver',
}

export enum PROJECTS_SORT_FIELD {
  createdAt = 'createdAt',
  customField = 'customField',
  customer = 'customer',
  endsOn = 'endsOn',
  name = 'name',
  number = 'number',
  officeName = 'officeName',
  primaryUser = 'primaryUser',
  startsOn = 'startsOn',
}

export enum PROJECT_CATEGORY {
  masterAgreement = 'masterAgreement',
  modification = 'modification',
  newBuilding = 'newBuilding',
  other = 'other',
  rehabilitation = 'rehabilitation',
  renovation = 'renovation',
}

export enum PROJECT_CLOSE_EMAIL_TYPE {
  projectClosed = 'projectClosed',
  rejection = 'rejection',
}

export enum PROJECT_COST_CATALOG_TYPE {
  custom = 'custom',
  din276 = 'din276',
  oenorm = 'oenorm',
  stlbWorkCategory = 'stlbWorkCategory',
}

export enum PROJECT_PHASE {
  allPhases = 'allPhases',
  estimation = 'estimation',
  tendering = 'tendering',
}

export enum PROJECT_STATUS {
  closed = 'closed',
  completed = 'completed',
  draft = 'draft',
  published = 'published',
}

export enum ProjectAuthActions {
  close = 'close',
  createBidPackage = 'createBidPackage',
  createBidPackage__withoutSelf = 'createBidPackage__withoutSelf',
  delete = 'delete',
  duplicate = 'duplicate',
  exportAllData = 'exportAllData',
  reopen = 'reopen',
  update = 'update',
  update__internalData = 'update__internalData',
  uploadInternalDocuments = 'uploadInternalDocuments',
  uploadSharedDocuments = 'uploadSharedDocuments',
  view = 'view',
  view__bim = 'view__bim',
  view__costAnalysis = 'view__costAnalysis',
  view__costEstimation = 'view__costEstimation',
  view__documents = 'view__documents',
  view__internalData = 'view__internalData',
  view__reportingData = 'view__reportingData',
  view__teams = 'view__teams',
}

export enum RATING_CATEGORY {
  addenda = 'addenda',
  adherenceToDeadlines = 'adherenceToDeadlines',
  availability = 'availability',
  bidQuality = 'bidQuality',
  cleanliness = 'cleanliness',
  communication = 'communication',
  environmentalAspects = 'environmentalAspects',
  invoicingAndBilling = 'invoicingAndBilling',
  negotiation = 'negotiation',
  occupationalSafety = 'occupationalSafety',
  priceLevel = 'priceLevel',
  qualityOfWork = 'qualityOfWork',
  reliability = 'reliability',
  timeManagement = 'timeManagement',
}

export enum REASON_PROPOSAL_BOQ_IS_OUTDATED {
  requestBoQDeleted = 'requestBoQDeleted',
  requestBoQUpdated = 'requestBoQUpdated',
}

export enum RECIPIENT_ENTITY_TYPE {
  Account = 'Account',
  Admin = 'Admin',
  Contact = 'Contact',
  User = 'User',
}

export enum REQUEST_PASSWORDLESS_LOGIN_CODE_FAILURE_REASON {
  userMissingOrDeactivated = 'userMissingOrDeactivated',
}

export enum SALESFORCE_PACKAGE_TYPE {
  bronze = 'bronze',
  enterprise = 'enterprise',
  freeTrial = 'freeTrial',
  gold = 'gold',
  noPricingPackage = 'noPricingPackage',
  silver = 'silver',
}

export enum SENT_EMAILS_SORT_FIELD {
  from = 'from',
  sentAt = 'sentAt',
  status = 'status',
  subject = 'subject',
  to = 'to',
}

export enum SIGNUP_SORT_FIELD {
  createdAt = 'createdAt',
  email = 'email',
  status = 'status',
}

export enum SIGNUP_STATUS {
  approved = 'approved',
  completed = 'completed',
  denied = 'denied',
  emailVerificationCode = 'emailVerificationCode',
  onHold = 'onHold',
  started = 'started',
}

export enum SIGNUP_TYPE {
  adminVerify = 'adminVerify',
  peerVerify = 'peerVerify',
  selfVerify = 'selfVerify',
}

export enum SIMULATION_CHANGE_STORE_ACTION {
  remove = 'remove',
  update = 'update',
}

export enum SIMULATION_CHANGE_TYPE {
  bidFreeQuantity = 'bidFreeQuantity',
  bidUnitPrice = 'bidUnitPrice',
  boqQuantity = 'boqQuantity',
  customBudgetFreeQuantity = 'customBudgetFreeQuantity',
  customBudgetUnitPrice = 'customBudgetUnitPrice',
}

export enum SORT_DIRECTION {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum STANDARD_USER_TYPE {
  administrator = 'administrator',
  collaborator = 'collaborator',
  employee = 'employee',
  guest = 'guest',
  manager = 'manager',
}

export enum STATE_CODE {
  DE_BB = 'DE_BB',
  DE_BE = 'DE_BE',
  DE_BW = 'DE_BW',
  DE_BY = 'DE_BY',
  DE_HB = 'DE_HB',
  DE_HE = 'DE_HE',
  DE_HH = 'DE_HH',
  DE_MV = 'DE_MV',
  DE_NI = 'DE_NI',
  DE_NW = 'DE_NW',
  DE_RP = 'DE_RP',
  DE_SH = 'DE_SH',
  DE_SL = 'DE_SL',
  DE_SN = 'DE_SN',
  DE_ST = 'DE_ST',
  DE_TH = 'DE_TH',
}

export enum STATUS_HISTORY_EMAIL_TEMPLATE_NAME {
  bidInvite = 'bidInvite',
  bidInviteNew = 'bidInviteNew',
  bidInviteReminder = 'bidInviteReminder',
  bidInviteReminderNew = 'bidInviteReminderNew',
  bidInviteReminderSC12989_V1 = 'bidInviteReminderSC12989_V1',
  bidInviteReminderSC12989_V2 = 'bidInviteReminderSC12989_V2',
  bidInviteSC12989_V1 = 'bidInviteSC12989_V1',
  bidInviteSC12989_V2 = 'bidInviteSC12989_V2',
  bidInviteSC12989_V3 = 'bidInviteSC12989_V3',
  bidInviteSC12989_V4 = 'bidInviteSC12989_V4',
  bidInviteSC12989_V5 = 'bidInviteSC12989_V5',
  bidInviteSC12989_V6 = 'bidInviteSC12989_V6',
  bidInviteSC22946_V1 = 'bidInviteSC22946_V1',
  bidInviteSC22946_V2 = 'bidInviteSC22946_V2',
  bidPackageChangedNotification = 'bidPackageChangedNotification',
  bidPackageClosed = 'bidPackageClosed',
  bidRequestAwardedNotification = 'bidRequestAwardedNotification',
  bidRequestRejectedNotification = 'bidRequestRejectedNotification',
  bidderIntroduction = 'bidderIntroduction',
  boqChangedNotification = 'boqChangedNotification',
  contractAgentRequest = 'contractAgentRequest',
  contractSignature = 'contractSignature',
  contractWithdrawn = 'contractWithdrawn',
  documentNotification = 'documentNotification',
  marketplaceBidRequestBidsDueNotification = 'marketplaceBidRequestBidsDueNotification',
  newMessageNotification = 'newMessageNotification',
}

export enum SUBCONTRACTORS_IMPORT_STATUS {
  failed = 'failed',
  initial = 'initial',
  pending = 'pending',
  running = 'running',
  succeeded = 'succeeded',
  validated = 'validated',
}

export enum SUBCONTRACTORS_SORT_FIELD {
  distance = 'distance',
  name = 'name',
}

export enum SUBCONTRACTORS_SORT_MODE {
  algorithmic = 'algorithmic',
  simple = 'simple',
}

export enum SUBCONTRACTOR_CLAIM_REFERENCE {
  bidInvite = 'bidInvite',
  marketplaceSuggestion = 'marketplaceSuggestion',
  sentEmail = 'sentEmail',
}

export enum SUBCONTRACTOR_IMPORT_ERROR_REASON {
  contactHasNoContactMethod = 'contactHasNoContactMethod',
  countryCodeMissing = 'countryCodeMissing',
  externalIdMissing = 'externalIdMissing',
  headersAreMissing = 'headersAreMissing',
  invalidContactEmailFormat = 'invalidContactEmailFormat',
  nameIsEmpty = 'nameIsEmpty',
  noContactsProvided = 'noContactsProvided',
  unsupportedCountryCode = 'unsupportedCountryCode',
}

export enum SUBCONTRACTOR_IMPORT_REQUEST_FILE_TYPE {
  auer = 'auer',
  brz = 'brz',
  cosuno = 'cosuno',
  itwo = 'itwo',
  microsoftTeams = 'microsoftTeams',
  nevaris = 'nevaris',
  orca = 'orca',
  other = 'other',
  outlook = 'outlook',
}

export enum SUBCONTRACTOR_IMPORT_REQUEST_STATUS {
  completed = 'completed',
  onHold = 'onHold',
  pending = 'pending',
}

export enum SUBCONTRACTOR_LIST_TYPE {
  company = 'company',
  companyAndNetwork = 'companyAndNetwork',
  network = 'network',
}

export enum SUBCONTRACTOR_MERGE_REQUEST_MATCH_TYPE {
  email = 'email',
  fuzzy = 'fuzzy',
  website = 'website',
}

export enum SUBCONTRACTOR_MERGE_REQUEST_SORT_FIELD {
  createdAt = 'createdAt',
  sourceSubcontractorName = 'sourceSubcontractorName',
  status = 'status',
  targetSubcontractorName = 'targetSubcontractorName',
}

export enum SUBCONTRACTOR_MERGE_REQUEST_STATUS {
  approved = 'approved',
  denied = 'denied',
  pending = 'pending',
}

export enum SUBCONTRACTOR_PRICING_TIER {
  tier1 = 'tier1',
  tier2 = 'tier2',
  tier3 = 'tier3',
  tier4 = 'tier4',
  tier5 = 'tier5',
}

export enum SUBCONTRACTOR_SUGGESTION_CHANGE_TYPE {
  delete = 'delete',
  update = 'update',
}

export enum SUBCONTRACTOR_SUGGESTION_FIELDS_CHANGE_TYPE {
  append = 'append',
  remove = 'remove',
  set = 'set',
  unset = 'unset',
}

export enum SUBCONTRACTOR_SUGGESTION_FIELDS_FIELD_NAME {
  city = 'city',
  companySize = 'companySize',
  countryCode = 'countryCode',
  description = 'description',
  foundingYear = 'foundingYear',
  logoKey = 'logoKey',
  name = 'name',
  nationalId = 'nationalId',
  orderAreaCountryCode = 'orderAreaCountryCode',
  orderAreaStateCodes = 'orderAreaStateCodes',
  orderAreaType = 'orderAreaType',
  orderRadius = 'orderRadius',
  ownerName = 'ownerName',
  postalCode = 'postalCode',
  pqNumber = 'pqNumber',
  registrationCity = 'registrationCity',
  registrationPostalCode = 'registrationPostalCode',
  revenueYear = 'revenueYear',
  street = 'street',
  taxId = 'taxId',
  website = 'website',
  workCategories = 'workCategories',
  yearlyRevenue = 'yearlyRevenue',
}

export enum SUBCONTRACTOR_SUGGESTION_FIELDS_REVIEW_RESULT {
  approved = 'approved',
  dismissed = 'dismissed',
}

export enum SUBCONTRACTOR_TYPE {
  company = 'company',
  network = 'network',
}

export enum SentEmailAuthActions {
  resend = 'resend',
  view = 'view',
}

export enum SignupAuthActions {
  approve = 'approve',
  delete = 'delete',
  deny = 'deny',
  onHold = 'onHold',
  view = 'view',
}

export enum SubcontractorAuthActions {
  addNote = 'addNote',
  ban = 'ban',
  changeSubcontractorAgentCompany = 'changeSubcontractorAgentCompany',
  createContact = 'createContact',
  createNetworkImport = 'createNetworkImport',
  delete = 'delete',
  favorite = 'favorite',
  importNetworkSubcontractors = 'importNetworkSubcontractors',
  manageCustomFields = 'manageCustomFields',
  managePrivateContacts = 'managePrivateContacts',
  merge = 'merge',
  rate = 'rate',
  requestCertificates = 'requestCertificates',
  restore = 'restore',
  submitCertificatesToRequest = 'submitCertificatesToRequest',
  suggestChanges = 'suggestChanges',
  update = 'update',
  uploadCertificateForSubcontractor = 'uploadCertificateForSubcontractor',
  view = 'view',
  viewNetworkImport = 'viewNetworkImport',
  view__bidRequests = 'view__bidRequests',
  view__certificates = 'view__certificates',
  view__notes = 'view__notes',
}

export enum SubcontractorNoteAuthActions {
  delete = 'delete',
  view = 'view',
}

export enum TASKS_SORT_FIELD {
  assignee = 'assignee',
  bidPackageName = 'bidPackageName',
  dueAt = 'dueAt',
  name = 'name',
  projectName = 'projectName',
  status = 'status',
}

export enum TASK_ASSIGNEE_TYPE {
  myCompany = 'myCompany',
  subcontractor = 'subcontractor',
}

export enum TASK_STATUS {
  done = 'done',
  inProgress = 'inProgress',
  todo = 'todo',
}

export enum TOGGLE_CONTRACT_DOCUMENT_RESULT {
  documentInfected = 'documentInfected',
  toggledSuccessfully = 'toggledSuccessfully',
  togglingInProgress = 'togglingInProgress',
}

export enum TRIAL_MODULE {
  costEstimationAndControlling = 'costEstimationAndControlling',
  individualisation = 'individualisation',
}

export enum TaskAuthActions {
  changeStatus = 'changeStatus',
  createNote = 'createNote',
  delete = 'delete',
  update = 'update',
  view = 'view',
}

export enum TaskNoteAuthActions {
  delete = 'delete',
  view = 'view',
}

export enum USERS_SORT_FIELD {
  company = 'company',
  department = 'department',
  email = 'email',
  jobTitle = 'jobTitle',
  lastActivityAt = 'lastActivityAt',
  name = 'name',
  status = 'status',
  userType = 'userType',
}

export enum USER_STATUS {
  active = 'active',
  adminApprovalPending = 'adminApprovalPending',
  approvalPending = 'approvalPending',
  inactive = 'inactive',
  inviteCanceled = 'inviteCanceled',
  inviteFailed = 'inviteFailed',
  inviteRequested = 'inviteRequested',
  invited = 'invited',
}

export enum USER_TYPE {
  administrator = 'administrator',
  collaborator = 'collaborator',
  custom = 'custom',
  employee = 'employee',
  guest = 'guest',
  manager = 'manager',
}

export enum UserAuthActions {
  approveOrDeleteJoinRequest = 'approveOrDeleteJoinRequest',
  confirmOrDeleteInviteRequest = 'confirmOrDeleteInviteRequest',
  deactivateOrReactivate = 'deactivateOrReactivate',
  delete = 'delete',
  deleteFailedInvite = 'deleteFailedInvite',
  resetMfaConfig = 'resetMfaConfig',
  resetPassword = 'resetPassword',
  update = 'update',
  update__personalInfo = 'update__personalInfo',
  update__typeAndOffices = 'update__typeAndOffices',
  view = 'view',
  view__mfaLastResetAt = 'view__mfaLastResetAt',
  view__mfaMethod = 'view__mfaMethod',
  view__privateData = 'view__privateData',
}

export enum VALIDATE_PASSWORDLESS_LOGIN_FAILURE_REASON {
  tokenExpired = 'tokenExpired',
}

export enum WORK_CATEGORY_SORT_FIELD {
  name = 'name',
  subcontractorsCount = 'subcontractorsCount',
}

export enum WORK_CATEGORY_TYPE {
  company = 'company',
  network = 'network',
}

export enum WORK_CATEGORY_TYPE_FILTER {
  allAvailable = 'allAvailable',
  company = 'company',
  network = 'network',
  onlyAssigned = 'onlyAssigned',
}

export enum WorkCategoryAuthActions {
  createNetworkWorkCategory = 'createNetworkWorkCategory',
  deleteNetworkWorkCategory = 'deleteNetworkWorkCategory',
  updateNetworkWorkCategory = 'updateNetworkWorkCategory',
  update__correspondingNetworkWorkCategories = 'update__correspondingNetworkWorkCategories',
  view = 'view',
}

export enum WorkCategoryTranslationAuthActions {
  update = 'update',
}
